export default "__VITE_ASSET__DoHYAwcG__"